import {Injectable, Injector} from '@angular/core';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {of} from 'rxjs';
import {catchError, map, mergeMap} from 'rxjs/operators';

import * as ac from './actions.command.test-mail-senden';
import * as api from '../../../clients/kommunikation';

@Injectable()
export class KommunikationTestMailSendenEffects {

    TestMailSenden$ = createEffect(() => this.actions$.pipe(
        ofType(ac.POST_TEST_MAIL_SENDEN),
        mergeMap((x: ac.PostTestMailSendenAction) => {
            const optPayload = (x !== undefined && x !== null && x.optPayload !== undefined) ? x.optPayload : null;
            return this.getService().postTestMailSenden(x.testMailRequest).pipe(
                map((result: any) => {
                    return new ac.PostTestMailSendenErfolgreichAction(x.testMailRequest, optPayload);
                }),
                catchError((error: any) => {
                    const nextAction = new ac.PostTestMailSendenFehlerAction(error, x.testMailRequest, optPayload);
                    return of(nextAction);
                })
            );
        })
    ));

    private service: api.MailCommandService = null;

    constructor(private actions$: Actions, private injector: Injector) {
    }

    private getService(): api.MailCommandService {
        if (this.service === null) {
            this.service = this.injector.get(api.MailCommandService);
        }
        return this.service;
    }
}
